import { createBrowserRouter } from "react-router-dom";
import ConnectMe from "../components/ConnectMe/ConnectMe";
import Cover from "../components/CoverSection/Cover";
import Home from "../components/Home/Home";
import Projects from "../components/Projects/Projects";
import Main from "../layout/Main";

export const routes = createBrowserRouter([
    {
        path:'/',
        element:<Main></Main>,
        children:[
            {
                path:'/',
                element:<Cover/>
            },
            {
                path:'/projects',
                element:<Projects/>
            },
            {
                path:'/contact',
                element:<ConnectMe/>
            }
        ]

    }
])